<template>
  <Modal :showing="showing" disable-scroll @close="$emit('close')">
    <div class="w-full max-w-md p-6">
      <h3 class="text-lg font-semibold mb-4 text-center text-gray-900">
        {{ $t('auth.appleSignInModal.title') }}
      </h3>
      <p class="text-gray-700 mb-6 text-center leading-relaxed">
        {{ $t('auth.appleSignInModal.message') }}
      </p>
      <div class="flex justify-center">
        <button
          class="px-6 py-3 bg-black text-white rounded-lg font-medium hover:bg-gray-900 transition-colors duration-200 focus:outline-hidden focus:ring-2 focus:ring-black/50"
          type="button"
          @click="$emit('close')"
        >
          {{ $t('auth.appleSignInModal.buttonText') }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script setup>
import Modal from '@/components/common/Modal.vue';

defineProps({
  showing: {
    type: Boolean,
    required: true,
  },
});

defineEmits(['close']);
</script>
